import {useQuery} from 'react-query'
import {SupplierEditModalForm} from './SupplierEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getSupplierById} from '../core/_requests'

const SupplierEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: supplier,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-supplier-${itemIdForUpdate}`,
    () => {
      return getSupplierById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <SupplierEditModalForm isSupplierLoading={isLoading} supplier={{id: undefined}} />
  }

  if (!isLoading && !error && supplier) {
    console.log({supplier, },"its supplier")
    console.log(typeof supplier,"its supplier")
    return <SupplierEditModalForm isSupplierLoading={isLoading} supplier={supplier} />
  }

  return null
}

export {SupplierEditModalFormWrapper}
